import * as React from "react";
/**
 * Context to provide the action creator loader to the components
 * This needs to be declared as "| null" to decouple the instantiation of the loader from the context
 */ export const ActionCreatorLoaderContext = React.createContext(null);
